import React from 'react';
import { IconUserCircle, spacer12 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { User } from 'types';
import Ellipsis from 'components/Ellipsis';
import { useTranslation } from 'providers/translations/TranslationProvider';

import UserProfileImage from './UserProfileImage';

const Profile = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-inline-end: ${spacer12};
  height: 48px;
`;

interface UserProfileProps {
  user: User;
}

const UserProfile = ({ user }: UserProfileProps) => {
  const { t, traw } = useTranslation();

  return (
    <Profile>
      <ImageWrapper>
        {user.images?.[0]?.url ? (
          <UserProfileImage
            src={user.images?.[0]?.url}
            width={48}
            height={48}
            alt={t('profile_image_alt')}
            data-testid="user-profile-image"
          />
        ) : (
          <IconUserCircle iconSize={48} aria-label={t('profile_image_alt')} data-testid="not-logged-user-icon" />
        )}
      </ImageWrapper>
      <Ellipsis variant="canon">{traw('greeting', { username: user.display_name || user.id })}</Ellipsis>
    </Profile>
  );
};

export default UserProfile;
